import { Dropdown } from 'primereact/dropdown';

import { useEffect, useState } from "react";
import { useGetCategoryQuery } from '../../../store/api/directory/categoryApi';
import { useOrderColumns } from '../../../hooks/orderColumns';


function DropDownEditor({
    data,
    label,
    placeholder,
    // onChange,
    onBlur,
    message,
    attr,
    opt,
    ...arr
}) {

    const [value, setValue] = useState(data?.[attr])
    function onChange(e) {
        setValue(e.value)
        onBlur(e, attr, e.value);
    }
    let options = useOrderColumns(opt);

    useEffect(() => {
        setValue(data?.[attr])
    }, [data?.[attr]])
    return (<>
        <div className="flex justify-content-center">
            <div className="editor">
                <label className="editor_label" htmlFor={label}>{label}</label>
                <Dropdown className="p-inputtext-dd"
                    id={label}
                    aria-describedby="username-help"
                    value={value}
                    options={options}
                    optionLabel='name'
                    optionValue='guid'
                    {...arr}
                    onChange={onChange}

                />
                {
                    message ?
                        <small id="username-help">
                            {message}
                        </small> : ""
                }
            </div>
        </div>
    </>);
}

export default DropDownEditor;